<app-top-bar-wrapper [type]="DashboardType.AI_PRESENCE">
    <div dashboard class="main-container">
        <app-overview-tiles [type]="'ai-presence'"
            [tooltips]="tooltips.overview"
            [overview]="overviewData"
            [loading]="loadingState.overview">
        </app-overview-tiles>
        <div class="widgets-wrapper">
            <div class="widget-container advertising-impact">
                <app-widget-container [title]="'Advertising Impact'" [tooltip]="tooltips.advertisingImpact">
                    <app-advertising-impact [data]="advertisingImpactData"
                        [loading]="loadingState.advertisingImpact"></app-advertising-impact>
                </app-widget-container>
            </div>
        </div>
        <div class="widgets-wrapper">
            <div class="widget-container topics-table" [class.fullHeight]="!topicsTableData || loadingState.topicsTable">
                <app-widget-container [title]="'Topics'" [tooltip]="tooltips.topics">
                    <app-topics-table [data]="topicsTableData" [loading]="loadingState.topicsTable"></app-topics-table>
                </app-widget-container>
            </div>
        </div>
        <div class="widgets-wrapper">
            <div class="widget-container ai-share-of-voice" [class.fullHeight]="!shareOfVoiceData || loadingState.shareOfVoice">
                <app-widget-container 
                    [title]="'AI Share of Voice'" 
                    [tooltip]="tooltips.aiShareOfVoice"
                    [selectMode]="SelectMode.SINGLE"
                    [selectWidth]="'200px'"
                    [control]="shareOfVoiceTopicsOptions.metricControl"
                    [selectOptions]="shareOfVoiceTopicsOptions.metricOptions"
                    [searchable]="shareOfVoiceTopicsOptions.searchable"
                    (apply)="onShareOfVoiceTopicChange()">
                    <app-ai-share-of-voice [data]="shareOfVoiceData" [loading]="loadingState.shareOfVoice"> </app-ai-share-of-voice>
                </app-widget-container>
            </div>
        </div>
    </div>
</app-top-bar-wrapper>